var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PrimaryButton',{staticClass:"o-primary-btn--modal-close c-modal__close-btn",on:{"click":_vm.emitClick}},[_vm._v(" × ")])
}
var staticRenderFns = []

export { render, staticRenderFns }